// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hcke","colMin":"styles_colMin__2LiJA"};